<header [ngStyle]="{ 'background': theme.Detail.HeaderBackground, 'color': theme.Detail.HeaderFontColor }">
  <strong *ngIf="!isTop" class="close-btn uwf-window-close" title="{{ resources.Close }}" (click)="toggleChat()"></strong>
  <h3 *ngIf="form.headerFooters[0].header; let headerText" [style.font-family]="theme.Detail.Font">{{ headerText }}</h3>
</header>
